import React from 'react'
import Header from './Header'

export default function Contact() {
  console.log('Hiii')
  return <h1>Contact</h1>
}
